import { ERROR_CODES } from "../../../constants/errorcodes";
import { SDK_EVENTS } from "../../../constants/events.cnst";

export class ErrorHandler {

    static hostInstance: any;

    private static disableErrorOverlay() {
        try {
            if (typeof window === 'undefined') return;
            
            // Type-safe way to modify window object
            const win = window as any;
            win.__REACT_ERROR_OVERLAY__ = false;
            
        } catch (error) {
            console.warn('Failed to disable error overlay:', error);
        }
    }

    static initialize(hostInstance: any) {
        this.hostInstance = hostInstance;
        this.disableErrorOverlay();

        if (typeof window === 'undefined') return;

        // Override console.error
        const originalConsoleError = console.error;
        console.error = (...args: any[]) => {
            if (args[0]?.includes?.('React will try to recreate this component tree')) {
                return;
            }
            originalConsoleError.apply(console, args);
        };

        // Global error handler
        window.onerror = (msg, url, lineNo, columnNo, error) => {
            this.emitError(error);
            console.warn('Global error:', { msg, url, lineNo, columnNo, error });
            return true;
        };

        // Unhandled promise rejection handler
        window.addEventListener('unhandledrejection', (event) => {
            console.warn('Unhandled promise rejection:', event.reason);
            this.emitError(event.reason);
            event.preventDefault();
            event.stopPropagation();
        }, true);

        // Runtime error handler
        window.addEventListener('error', (event) => {
            console.warn('Runtime error:', event.error);
            this.emitError(event.error);
            event.preventDefault();
            event.stopPropagation();
        }, true);
    }

    static emitError(error: any) {
        if (!this.hostInstance) {
            console.error('ErrorHandler not properly initialized with hostInstance');
            return;
        }      
        this.hostInstance.emit(SDK_EVENTS.ON_ERROR, {
            ...ERROR_CODES['ERR_JS_CODE'],
            originalError: error
        });
    }

    static wrapExternalCall<T>(fn: () => T, fallback: T): T {
        try {
            const result = fn();
            return result ?? fallback;
        } catch (error) {
            console.warn('External call failed:', error);
            return fallback;
        }
    }
}
